(function () {
  function pickCloudflareUrl(mediaEl) {
    try {
      if (window.__CF_HD__) {
        const { byColor, list, single, colorSlug } = window.__CF_HD__;
        const index = parseInt(mediaEl.getAttribute('data-media-index') || '0', 10) || 0;

        if (byColor && colorSlug && Array.isArray(byColor[colorSlug]) && byColor[colorSlug][index]) {
          return byColor[colorSlug][index];
        }
        if (list && Array.isArray(list) && list[index]) {
          return list[index];
        }
        if (single && index === 0) {
          return single;
        }
      }

      const img = mediaEl.querySelector('img');
      if (img && img.alt && img.alt.indexOf('CF:') >= 0) {
        const after = img.alt.split('CF:').pop().trim();
        const first = after.split(/\s+/)[0];
        if (first) return first;
      }
    } catch (e) {}
    return '';
  }

  function buildCFSrcset(base, widths, q) {
    return widths.map(w => `${base}?w=${w}&q=${q}&format=auto ${w}w`).join(', ');
  }

  function swapOne(mediaEl, q, hero) {
    const img = mediaEl.querySelector('img');
    if (!img) return;

    const cfBase = pickCloudflareUrl(mediaEl);
    const fallbackSrc = img.getAttribute('src') || '';
    if (!cfBase) return;

    const widths = hero ? [3840, 3000, 2000, 1500, 1100, 750, 535, 360, 165] : [1500, 1100, 750, 535, 360, 165];
    const defaultW = hero ? 1500 : 1100;

    const src = `${cfBase}?w=${defaultW}&q=${q}&format=auto`;
    const srcset = buildCFSrcset(cfBase, widths, q);

    img.setAttribute('src', src);
    img.setAttribute('srcset', srcset);
    if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');

    img.onerror = function () {
      this.onerror = null;
      if (fallbackSrc) this.src = fallbackSrc;
    };
  }

  function run() {
    const mediaItems = document.querySelectorAll('.product__media-item[data-media-type="image"]');
    if (!mediaItems.length) return;

    mediaItems.forEach((item, i) => {
      if (!item.hasAttribute('data-media-index')) {
        item.setAttribute('data-media-index', String(i));
      }
      const hero = i === 0;
      swapOne(item, 95, hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // 如主题在变体切换后重绘媒体，可以再触发
  document.addEventListener('product:media:refresh', run);
})();
